import React from 'react'
import PropTypes from 'prop-types'
import { Card } from 'antd'
import ItemProgressBar from './ItemProgressBar'
import ItemDetail from './ItemDetail'
import ItemImages from './ItemImages'

const Item = ({ item }) => (
  <div className="ProductionProgress">
    <Card title={item.name}>
      <ItemProgressBar item={item}/>
      <ItemDetail item={item}/>
      <ItemImages item={item}/>
    </Card>
  </div>
)

Item.propTypes = {
  item: PropTypes.object
}

export default Item
